import { SafeRecommendationPanel } from '@jira/admin-pages__performance/src/SafeRecommendationPanel.tsx';
import {
	composeLayouts,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';

/**
 * Compose the global settings layout with the recommendation panel right sidebar.
 * This is used specifically for the performance dashboard route.
 *
 * By moving this composition to a separate file that's not at the route entry level,
 * we defer the evaluation and avoid webpack null-loader issues during SSR route generation.
 */
export const performanceLayoutWithRightSidebar: Layout = composeLayouts(globalSettingsLayout, {
	rightSidebars: [SafeRecommendationPanel],
});

export default performanceLayoutWithRightSidebar;
